import { UserInfo } from '../models/UserInfo';

export type UserInfoAction =
  | {
      type: 'INIT';
      userInfo: UserInfo;
    }
  | {
      type: 'COMMUNITY_OPT_IN';
    }
  | {
      type: 'COMMUNITY_OPT_OUT';
    }
  | {
      type: 'CARE_TEAM_SLA_ACCEPTED';
    }
  | {
      type: 'PROFILE_SETUP';
    }
  | {
      type: 'EVENT_SLA';
    };

export const userInfoReducer = (
  currentState: UserInfo | null,
  action: UserInfoAction,
): UserInfo | null => {
  const actionType = action.type;
  if (actionType === 'INIT') {
    return action.userInfo;
  }

  if (!currentState) {
    return currentState;
  }

  if (actionType === 'COMMUNITY_OPT_IN') {
    return { ...currentState, community_opt_in: true };
  } else if (actionType === 'COMMUNITY_OPT_OUT') {
    return { ...currentState, community_opt_in: false };
  } else if (actionType === 'CARE_TEAM_SLA_ACCEPTED') {
    return { ...currentState, ccm_sla_acknowledged: true };
  } else if (actionType === 'PROFILE_SETUP') {
    return { ...currentState, profile_setup: true };
  } else if (actionType === 'EVENT_SLA') {
    return { ...currentState, event_sla_acknowledged: true };
  }
  return currentState;
};
